<template>
  <div>
    <Table
      ref="dataTable"
      border
      :columns="tableColumnShow"
      :data="tableDataShow"
      :loading="tableLoading"
      @on-row-click="selectRow"
      @on-select="selectOneData"
      @on-select-cancel="cancelOneData"
      @on-select-all="selectAllData"
      @on-select-all-cancel="cancelAllData"
    >
      <template slot="radio" slot-scope="{ row }">
        <Radio
          :disabled="!!row._disabled"
          :value="row.tag"
        ></Radio>
      </template>
    </Table>
    <Page
      v-if="showPage"
      :total="tableTotal"
      show-total
      :current="tableCurrent"
      class="page-right"
      @on-change="changePage"
    ></Page>
  </div>
</template>
<script>
export default {
  props: {
    // 表格的column
    tableColumn: {
      type: Array,
      default: () => []
    },
    // 表格的数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表格数据的总数量
    tableTotal: {
      type: Number,
      default: 0
    },
    // 表格数据的当前第几页
    tableCurrent: {
      type: Number,
      default: 1
    },
    selectType: {
      type: Number,
      default: 1 // 1代表表格单选，2代表表格多选
    },
    showPage: {
      type: Boolean,
      default: true
    }, // 是否展示分页
    tableLoading: {
      type: Boolean,
      default: false // 数据是否在加载
    },
    value: {
      type: Array,
      default: () => []
    }, // v-model的值
    singleSelectData: {
      type: [Object, null, String, Number],
      default: () => {}
    }, // 单选的值
    uniqueKey: {
      type: String,
      default: 'userId'
    }
  },
  emits: [
    // 写法与绑定单个值一样   只不过也是父组件绑定多少个就写多少个
    'update:singleSelectData'
  ],
  data() {
    return {
      // singleSelectData: {} // 选中的数据(针对单选的)
    };
  },
  computed: {
    tableColumnShow() {
      // 添加表格单选框
      const selectArray = [{
        title: ' ',
        slot: 'radio',
        width: 60,
        fixed: 'left'
      }];
      // 添加表格多选框
      const selectMore = [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        }
      ];
      if (this.selectType === 1) {
        return selectArray.concat(this.tableColumn);
      } else {
        return selectMore.concat(this.tableColumn);
      }
    },
    tableDataShow() {
      const singleObj = this.singleSelectData ? this.singleSelectData : {};
      return this.tableData.map(item => {
        const { _checked: _checked1, tag: tag1, ...otherDataItem } = item;
        const itemTag = item[this.uniqueKey] === singleObj[this.uniqueKey];
        // itemTag ? this.$emit('update:singleSelectData', otherDataItem) : '';
        let _checked = false;
        const index = this.selectTableData.findIndex(x => {
          return x[this.uniqueKey] === item[this.uniqueKey];
        });
        index === -1 ? '' : _checked = true;
        return { _checked, tag: itemTag, ...otherDataItem };
      });
    },
    selectTableData: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  methods: {
    // 点击了分页页码
    changePage(page) {
      this.$emit('pageChange', page);
    },
    // 选择某一行
    selectRow(row, index) {
      if (row._disabled) {
        return;
      }
      if (this.selectType === 1) {
        this.$emit('update:singleSelectData', row);
      } else if (this.selectType === 2) {
        this.$refs.dataTable.toggleSelect(index);
      }
    },
    // 多选状态下勾选了一条数据
    selectOneData(_, row) {
      this.selectTableData.push(row);
    },
    // 多选状态下取消了一条数据
    cancelOneData(_, row) {
      // const { tag: tag1, _checked: _checked1, ...otherData } = row;
      this.selectTableData = this.selectTableData.filter(item => {
        return row[this.uniqueKey] !== item[this.uniqueKey];
      });
    },
    // 多选状态下勾选全部数据
    selectAllData(selection) {
      selection.forEach(item => {
        const index = this.selectTableData.findIndex(x => {
          return item[this.uniqueKey] === x[this.uniqueKey];
        });
        index === -1 ? this.selectTableData.push(item) : '';
      });
    },
    cancelAllData(_) {
      this.selectTableData = this.selectTableData.filter(item => {
        return !this.selectTableData.some(x => {
          return item[this.uniqueKey] === x[this.uniqueKey];
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-right {
  text-align: right;
  margin-top: 16px;
}
.modal-footer {
  margin-top: 32px;
  text-align: right;
  button + button {
    margin-left: 16px;
  }
}
</style>
